import React from 'react';
import { 
  ExclamationCircleFilled, 
  QuestionCircleOutlined, 
  InfoCircleOutlined,
  WarningOutlined,
  CheckCircleOutlined
} from '@ant-design/icons';
import { Modal } from 'antd';

const { confirm } = Modal;

// Default configurations for different modal types
const modalTypes = {
  confirm: {
    icon: <QuestionCircleOutlined style={{ color: '#1890ff' }} />,
    okType: 'primary',
    confirmButtonText: 'Yes',
    cancelButtonText: 'No'
  },
  warning: {
    icon: <WarningOutlined style={{ color: '#faad14' }} />,
    okType: 'primary',
    confirmButtonText: 'Yes',
    cancelButtonText: 'No'
  },
  info: {
    icon: <InfoCircleOutlined style={{ color: '#1890ff' }} />,
    okType: 'primary',
    confirmButtonText: 'OK',
    cancelButtonText: 'Cancel'
  },
  success: {
    icon: <CheckCircleOutlined style={{ color: '#52c41a' }} />,
    okType: 'primary',
    confirmButtonText: 'OK',
    cancelButtonText: 'Cancel'
  },
  danger: {
    icon: <ExclamationCircleFilled style={{ color: '#ff4d4f' }} />,
    okType: 'danger',
    confirmButtonText: 'Yes',
    cancelButtonText: 'No'
  }
};

// Generic modal function - fully dynamic
const showModal = ({
  type = 'confirm',
  title = "Confirm",
  text = "Are you sure?",
  confirmButtonText,
  cancelButtonText,
  icon,
  okType,
  width = 400,
  centered = true,
  showCancelButton = true,
  zIndex = 999999,
  onOk,
  onCancel,
  closable = true,    
  maskClosable = true,
  ...otherProps
} = {}) => {
  // Get default configuration for the type
  const typeConfig = modalTypes[type] || modalTypes.confirm;
  
  return new Promise((resolve) => {
    confirm({
      title: title,
      icon: icon || typeConfig.icon,
      content: text,
      okText: confirmButtonText || typeConfig.confirmButtonText,
      okType: okType || typeConfig.okType,
      cancelText: cancelButtonText || typeConfig.cancelButtonText,
      showCancelButton: showCancelButton,
      width: width,
      centered: centered,
      zIndex: zIndex,
      closable: closable,
      maskClosable: maskClosable,
      onOk() {
        if (onOk) onOk();
        resolve(true);
      },
      onCancel() {
        if (onCancel) onCancel();
        resolve(false);
      },
      ...otherProps
    });
  });
};

// Convenience methods for different modal types
const showConfirm = (props = {}) => showModal({ type: 'confirm', ...props });
const showWarning = (props = {}) => showModal({ type: 'warning', ...props });
const showInfo = (props = {}) => showModal({ type: 'info', ...props });
const showSuccess = (props = {}) => showModal({ type: 'success', ...props });
const showDanger = (props = {}) => showModal({ type: 'danger', ...props });

// Legacy methods for backward compatibility
const showDeleteConfirm = (title = "Are you sure delete this item?", content = "This action cannot be undone.") => {
  return showDanger({
    title: title,
    text: content
  });
};

export default {
  showModal,
  showConfirm,
  showWarning,
  showInfo,
  showSuccess,
  showDanger,
  showDeleteConfirm,
  modalTypes
};
